import { differenceInCalendarDays, parseDateOnly, startOfDay } from "@nimit9/signet-lib/format"

/**
 * Paisa-specific date helpers that build on Signet's date-only primitives
 * (`parseDateOnly` / `toDateOnly` / `startOfYear`, imported directly from
 * `@nimit9/signet-lib/format` at call sites). Signet doesn't have an
 * opinion on "days until" or headline-style relative-date phrasing, so
 * those stay here.
 */

/** Whole calendar days from `today` to `value` (negative = in the past).
 * DST-safe: Signet's differenceInCalendarDays counts calendar dates, not
 * 24-hour spans. NaN if `value` isn't a valid "YYYY-MM-DD". */
export function daysUntil(value: string, today: Date = new Date()): number {
  return differenceInCalendarDays(parseDateOnly(value), startOfDay(today))
}

/** "28 Sept" (en-IN short month, no year): how a date reads inside a headline sentence. */
export function dayMonth(value: string): string {
  return parseDateOnly(value).toLocaleDateString("en-IN", { day: "numeric", month: "short" })
}

/** "on 28 Sept" / "today" / "tomorrow" relative to `today`. */
export function onDay(value: string, today: Date = new Date()): string {
  const days = daysUntil(value, today)
  if (days === 0) return "today"
  if (days === 1) return "tomorrow"
  return `on ${dayMonth(value)}`
}
